import { useLogin } from '@privy-io/react-auth';

import { guestLogin as guestLoginService, updateUserAttribution } from '../services/auth.service';
import { verifyRefCode } from '../services/user.service';
import { getDeviceId } from '../utils';
import useUserStore from '../stores/user.store';
import useAvailabilityStore from '../stores/availability.store';

let guestLoginInProgress = false;

function useCustomLogin() {
  const setUser = useUserStore((state) => state.setUser);
  const setOpenModal = useAvailabilityStore((state) => state.setOpenModal);
  const setMessage = useAvailabilityStore((state) => state.setMessage);
  const { login } = useLogin({
    onError: async (err) => {
      console.error(err);
      console.error(`----- err login, ${err.message} -----`);
    },
    onOAuthLoginComplete: async () => {},
    onComplete: async () => {},
  });

  const guestLogin = async () => {
    if (guestLoginInProgress) return;
    guestLoginInProgress = true;

    try {
      const deviceId = getDeviceId();
      const res = await guestLoginService({ deviceId });

      const { user, tokens } = res.data;
      const attribution = localStorage.getItem('ff_attribution');
      if (attribution) {
        await updateUserAttribution(user.id, JSON.parse(attribution));
      }

      localStorage.setItem('fishAuth', tokens.access.token);
      localStorage.setItem('refreshToken', tokens.refresh.token);
      localStorage.setItem('userId', user.id);
      localStorage.setItem('isGuest', true);
      setUser(user);

      const refCode = localStorage.getItem('ff-ref-code');
      if (refCode) {
        verifyRefCode(refCode)
          .then(() => console.log(`verify ref code ok, code ${refCode}`))
          .catch((err) => console.error(`----- err verifyRefCode, code ${refCode}, err ${err.message} -----`))
          .finally(() => localStorage.removeItem('ff-ref-code'));
      }
    } catch (err) {
      console.error(err);
      console.error(`----- err guestLogin, ${err.message} -----`);
      if (err.code === 429 || err.code === 403) {
        setMessage(err.message);
        setOpenModal(true);
      }
    } finally {
      guestLoginInProgress = false;
    }
  };

  return { login, guestLogin };
}

export default useCustomLogin;
